module.exports = __webpack_public_path__ + "static/media/employee-section.4d75aecd.png";